(function () {
  "use strict";
  var root = document.getElementById("genkidama-product-comments");
  if (!root) return;

  var product = {
    product_id: root.dataset.productId || "",
    product_handle: root.dataset.productHandle || "",
    product_title: root.dataset.productTitle || "",
    product_url: root.dataset.productUrl || "",
    product_sku: root.dataset.productSku || "",
    variant_id: root.dataset.variantId || ""
  };
  var selectedRating = 0;
  var imagePayload = { image_data: "", image_name: "" };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatDate(value) {
    try {
      return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }).format(new Date(value));
    } catch (err) {
      return value || "";
    }
  }

  function stars(rating) {
    var count = Math.max(0, Math.min(5, Number(rating || 0)));
    return "★★★★★".slice(0, count);
  }

  function bodyHtml(body) {
    var text = String(body || "").trim();
    if (!text) return '<em class="gkc-muted">Nur Bewertung</em>';
    return escapeHtml(text).replace(/\n/g, "<br>");
  }

  function imageHtml(comment) {
    if (!comment.image_url) return "";
    var src = "/apps/genkidama" + comment.image_url;
    return '<a class="gkc-image" href="' + escapeHtml(src) + '" target="_blank" rel="noopener"><img src="' + escapeHtml(src) + '" alt="Kommentarbild"></a>';
  }

  function renderShell() {
    root.innerHTML = [
      '<section class="gkc-box" aria-label="Produkt-Kommentare">',
      '  <div class="gkc-head">',
      '    <div><h2>Kommentare</h2><p>Nur eingeloggte Mitglieder koennen schreiben.</p></div>',
      '    <button class="gkc-refresh" type="button">Aktualisieren</button>',
      '  </div>',
      '  <div class="gkc-list" data-gkc-list>Lade Kommentare...</div>',
      '  <form class="gkc-form" data-gkc-form>',
      '    <fieldset class="gkc-rating"><legend>Bewertung</legend>',
      '      <button type="button" data-rating="5">5 Sterne</button>',
      '      <button type="button" data-rating="4">4 Sterne</button>',
      '      <button type="button" data-rating="3">3 Sterne</button>',
      '      <button type="button" data-rating="2">2 Sterne</button>',
      '      <button type="button" data-rating="1">1 Stern</button>',
      '    </fieldset>',
      '    <textarea class="gkc-text" name="body" maxlength="2000" placeholder="Kommentar schreiben (optional bei Bewertung)..."></textarea>',
      '    <label class="gkc-file">Bild hochladen (optional. JPG/PNG bis 3 MB)<input type="file" name="image" accept="image/jpeg,image/png"></label>',
      '    <div class="gkc-form-row"><span class="gkc-status" data-gkc-status></span><button class="gkc-submit" type="submit">Senden</button></div>',
      '  </form>',
      '</section>'
    ].join("");
  }

  function renderComments(comments) {
    var list = root.querySelector("[data-gkc-list]");
    if (!list) return;
    if (!comments.length) {
      list.innerHTML = '<div class="gkc-empty">Noch keine Kommentare vorhanden.</div>';
      return;
    }
    list.innerHTML = comments.map(function (comment) {
      return [
        '<article class="gkc-comment">',
        '  <div class="gkc-comment-meta">',
        '    <strong>' + escapeHtml(comment.public_name || "Mitglied") + '</strong>',
        '    <span>' + escapeHtml(formatDate(comment.created_at)) + '</span>',
        '  </div>',
        comment.rating ? '  <div class="gkc-stars" aria-label="' + escapeHtml(comment.rating) + ' von 5 Sternen">' + stars(comment.rating) + '</div>' : '',
        imageHtml(comment),
        '  <div class="gkc-comment-body">' + bodyHtml(comment.body) + '</div>',
        '</article>'
      ].join("");
    }).join("");
  }

  async function loadComments() {
    var url = "/apps/genkidama/comments?product_id=" + encodeURIComponent(product.product_id) +
      "&product_handle=" + encodeURIComponent(product.product_handle);
    var response = await fetch(url, { credentials: "same-origin" });
    var data = await response.json();
    if (!data.ok) throw new Error(data.error || "Fehler");
    renderComments(data.comments || []);
  }

  function setStatus(message, kind) {
    var status = root.querySelector("[data-gkc-status]");
    if (!status) return;
    status.textContent = message || "";
    status.dataset.kind = kind || "";
  }

  function markRating() {
    root.querySelectorAll("[data-rating]").forEach(function (button) {
      button.classList.toggle("is-active", Number(button.dataset.rating) === selectedRating);
    });
  }

  function readImage(file) {
    return new Promise(function (resolve, reject) {
      if (!file) {
        resolve({ image_data: "", image_name: "" });
        return;
      }
      if (!/^image\/(jpeg|png)$/i.test(file.type || "")) {
        reject(new Error("Bitte nur JPG oder PNG hochladen."));
        return;
      }
      if (file.size > 3 * 1024 * 1024) {
        reject(new Error("Das Bild darf maximal 3 MB gross sein."));
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        resolve({ image_data: String(reader.result || ""), image_name: file.name || "kommentarbild" });
      };
      reader.onerror = function () {
        reject(new Error("Bild konnte nicht gelesen werden."));
      };
      reader.readAsDataURL(file);
    });
  }

  async function submitComment(event) {
    event.preventDefault();
    var form = event.currentTarget;
    if (!selectedRating) {
      setStatus("Bitte Bewertung auswaehlen.", "error");
      return;
    }
    setStatus("Wird gesendet...", "");
    var body = String((form.elements.body && form.elements.body.value) || "").trim();
    var payload = Object.assign({}, product, {
      rating: selectedRating,
      body: body,
      image_data: imagePayload.image_data,
      image_name: imagePayload.image_name
    });
    try {
      var response = await fetch("/apps/genkidama/comments", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      var data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.error || "Fehler");
      form.reset();
      imagePayload = { image_data: "", image_name: "" };
      selectedRating = 0;
      markRating();
      setStatus("Danke. Dein Kommentar wartet auf Freigabe.", "ok");
      loadComments().catch(function () {});
    } catch (err) {
      setStatus(err.message === "login_required" ? "Bitte zuerst einloggen." : "Senden fehlgeschlagen.", "error");
    }
  }

  function bindEvents() {
    root.querySelector(".gkc-refresh").addEventListener("click", function () {
      loadComments().catch(function () {
        renderComments([]);
      });
    });
    root.querySelectorAll("[data-rating]").forEach(function (button) {
      button.addEventListener("click", function () {
        selectedRating = Number(button.dataset.rating || 0);
        markRating();
      });
    });
    var file = root.querySelector('input[type="file"]');
    if (file) {
      file.addEventListener("change", function () {
        readImage(file.files && file.files[0]).then(function (value) {
          imagePayload = value;
          setStatus(value.image_name ? "Bild bereit." : "", "");
        }).catch(function (err) {
          file.value = "";
          imagePayload = { image_data: "", image_name: "" };
          setStatus(err.message, "error");
        });
      });
    }
    root.querySelector("[data-gkc-form]").addEventListener("submit", submitComment);
  }

  function addStyles() {
    if (document.getElementById("gkc-styles")) return;
    var style = document.createElement("style");
    style.id = "gkc-styles";
    style.textContent = [
      ".gkc-box{border:1px solid #ff5a00;border-radius:8px;padding:18px;margin:24px 0;background:#fffaf6;color:#1f1713}",
      ".gkc-head{display:flex;justify-content:space-between;gap:16px;align-items:flex-start;margin-bottom:14px}",
      ".gkc-head h2{margin:0 0 4px;font-family:var(--font-heading-family,Georgia,serif);font-size:28px;letter-spacing:0}",
      ".gkc-head p{margin:0;color:#6f625b}",
      ".gkc-refresh,.gkc-submit{border:0;border-radius:6px;background:#ff5a00;color:#fff;font-weight:700;padding:10px 14px;cursor:pointer}",
      ".gkc-list{display:grid;gap:12px;margin-bottom:18px}",
      ".gkc-list,.gkc-list *{user-select:text}",
      ".gkc-empty{border:1px dashed #e9c8b8;border-radius:6px;padding:16px;background:#fff}",
      ".gkc-comment{border:1px solid #f0d2c3;border-radius:6px;background:#fff;padding:14px}",
      ".gkc-comment-meta{display:flex;justify-content:space-between;gap:12px;color:#6f625b;font-size:13px;margin-bottom:6px}",
      ".gkc-comment-meta strong{color:#1f1713}",
      ".gkc-stars{color:#ff8a00;font-weight:700;margin-bottom:8px}",
      ".gkc-comment-body{line-height:1.45}",
      ".gkc-muted{color:#6f625b}",
      ".gkc-image{display:inline-block;margin:8px 0;border:1px solid #f0d2c3;border-radius:6px;overflow:hidden;background:#fff}",
      ".gkc-image img{display:block;max-width:180px;height:auto}",
      ".gkc-form{display:grid;gap:12px}",
      ".gkc-rating{border:0;margin:0;padding:0;display:flex;flex-wrap:wrap;gap:10px;align-items:center}",
      ".gkc-rating legend{font-weight:700;margin-right:8px}",
      ".gkc-rating button{border:1px solid #c9c2bd;background:#fff;border-radius:999px;padding:8px 12px;cursor:pointer}",
      ".gkc-rating button.is-active{border-color:#ff5a00;background:#fff0e6;color:#c44200;font-weight:700}",
      ".gkc-text{min-height:130px;resize:vertical;border:1px solid #c9c2bd;border-radius:6px;padding:12px;font:inherit}",
      ".gkc-file{display:grid;gap:6px;font-size:13px}",
      ".gkc-form-row{display:flex;justify-content:space-between;gap:12px;align-items:center}",
      ".gkc-status[data-kind='ok']{color:#00884a}.gkc-status[data-kind='error']{color:#b42318}",
      "@media(max-width:640px){.gkc-head,.gkc-form-row{display:grid}.gkc-refresh,.gkc-submit{width:100%}}"
    ].join("");
    document.head.appendChild(style);
  }

  addStyles();
  renderShell();
  bindEvents();
  loadComments().catch(function () {
    renderComments([]);
  });
})();
